module.exports = __webpack_public_path__ + "static/sport/img-swiper1.f8f15b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/img-swiper1.png
// module id = MdQ4
// module chunks = 0